module.exports = __webpack_public_path__ + "static/img/yunpic3.090f55c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunpic3.jpg
// module id = DVWV
// module chunks = 0